import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {UserSubscription} from "../../../user/user-subscription";
import {Website} from "../../website/website";

@Component({
    selector: 'db-domains-exceeded',
    templateUrl: './domains-exceeded.component.html',
    styleUrls: ['./domains-exceeded.component.scss'],
    standalone: false
})
export class DomainsExceededComponent implements OnInit {
  @Input() filteredWebsites?: Website[];
  @Input() hostingsLimit?: any;
  @Input() upgradeAvailable?: boolean;
  @Input() showImage?: boolean = true;
  @Input() buttonColor?: string;
  @Input() hostingTrialFlow?: boolean;
  @Input() automaticMigration?: boolean;
  @Input() hostingTrialExpired?: boolean;
  @Input() currentSubscription?: UserSubscription;
  @Input() showBackButton?: boolean = false;
  @Input() title?: string;
  @Input() description?: string;
  @Input() addWebsite?: boolean;
  @Input() showTrialClass?: boolean = false;
  @Input() agencyOrFreelancer?: boolean = false;
  @Output() prevStep = new EventEmitter<any>();
  @Output() buyWebsite = new EventEmitter<any>();


  constructor() {
  }

  ngOnInit() {}

  public goBack(): void {
    this.prevStep.emit(true);
  }

  public buyNow(): void {
    this.buyWebsite.emit(true);
  }

}
